import Excel from 'exceljs';
import zipObject from 'lodash.zipobject';

const convertWorksheetToArray = worksheet => {
  const HEADER_ROW_INDEX = 1;
  const rows = [];

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === HEADER_ROW_INDEX) {
      return;
    }
    const rowValues = row.values;
    rowValues.shift();

    rows.push(rowValues);
  });

  return rows;
};

export const loadDataFromExcelFileBuffer = async ({ fileBuffer, excelColumnNames }) => {
  const workbook = new Excel.Workbook();
  await workbook.xlsx.load(fileBuffer);
  const worksheet = workbook.worksheets[0];
  const rows = convertWorksheetToArray(worksheet)
    .map(row => zipObject(excelColumnNames, row))
    .filter(row => {
      const isRowEmpty = Object.values(row).every(cell => !cell && cell !== 0);
      return !isRowEmpty;
    });
  return rows;
};

export const createExcelReport = async ({
  newElements,
  removedElements,
  requiredAttribChanged,
}) => {
  const workbook = new Excel.Workbook();
  const headers = ['Element Name', 'Description', 'Data Type', 'Length'];

  const addWorksheetWithData = (workbook, sheetName, data) => {
    const worksheet = workbook.addWorksheet(sheetName);
    worksheet.columns = headers.map(header => ({
      header,
      key: header,
      style: {
        font: {
          size: 13,
          bold: true,
        },
      },
    }));

    if (data.length > 0) {
      const headers = Object.keys(data[0]);
      worksheet.columns = headers.map(header => ({ header, key: header }));

      data.forEach(row => worksheet.addRow(row));
      worksheet.columns.forEach(column => {
        let maxLength = column.header.length;
        column.eachCell({ includeEmpty: true }, cell => {
          const cellLength = cell.value ? cell.value.toString().length : 0;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });
        column.width = maxLength;
      });
    }
  };

  addWorksheetWithData(workbook, 'New Elements', newElements);
  addWorksheetWithData(workbook, 'Removed Elements', removedElements);
  addWorksheetWithData(workbook, 'Required Attrib Changed', requiredAttribChanged);

  const buffer = await workbook.xlsx.writeBuffer();

  return buffer;
};
